import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import translate from '@noar-basf/commons';

class FormActions extends React.Component {
  render() {

    const {formIsValid,
      onCleanForm,
      isEdit,
      module
    } = this.props;

    return (
      <div className='text-right'>
        <Button variant="primary"
          type="submit"
          disabled={!formIsValid}
          title={formIsValid ? 'Submeter formulário' : 'Verifique os campos'}
          className='mr-3'>
          {translate(this.props.i18n.lang).buttons.save}
        </Button>

        <Button variant="secondary"
          onClick={onCleanForm}
          className='mr-3'>
          {!isEdit
            ? translate(this.props.i18n.lang).buttons.clean
            : translate(this.props.i18n.lang).buttons.revert
          }
        </Button>

        <Link to={`/admin/${module}`} >
          <Button variant="secondary" type="button">
            {translate(this.props.i18n.lang).buttons.cancel}
          </Button>
        </Link>
      </div>
    );
  }
}

const mapStateToProps = store => ({
  i18n: store.i18n
});

export default connect(mapStateToProps)(FormActions);
